var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMydeskBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "668px",
    height: "168px",
    viewBox: "0 0 668 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 62.25,
    x2: 127.2,
    y2: 62.25,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#223667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#223B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 136.525,
    y1: 95,
    x2: 237.775,
    y2: 95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#233B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#23407B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 247.32500000000002,
    y1: 62.25,
    x2: 348.27500000000003,
    y2: 62.25,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#23407C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#244584"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 357.9,
    y1: 73.8,
    x2: 447.5,
    y2: 73.8,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#244585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#25498D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 495.45,
    y1: 152.95,
    x2: 638.05,
    y2: 152.95,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#254B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#27529E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 456.775,
    y1: 73.8,
    x2: 534.025,
    y2: 73.8,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25498E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#264D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 550.525,
    y1: 59.2,
    x2: 639.0749999999999,
    y2: 59.2,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#27529E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MD_Blue_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 127.2 6.1 L 95 6.1 63.85 83.9 32.35 6.1 0 6.1 0 118.45 27.35 118.45 27.35 50.95 52.7 118.45 74.7 118.45 99.85 51.1 99.85 118.45 127.2 118.45 127.2 6.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    stroke: "none",
    d: " M 237.8 29.15 L 208.2 29.15 187.7 85 167.1 29.15 136.55 29.15 172.85 115.4 152.4 160.85 181.85 160.85 237.8 29.15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_3)",
    stroke: "none",
    d: " M 341.05 91.6 Q 348.3 78.75 348.3 62.3 348.3 45.65 341.05 32.9 333.8 20.25 320.5 13.15 307.2 6.1 289.5 6.1 L 247.35 6.1 247.35 118.45 289.5 118.45 Q 307.05 118.45 320.4 111.4 333.8 104.4 341.05 91.6 M 287.7 29.45 Q 303.25 29.45 311.85 38.15 320.5 46.8 320.5 62.3 320.5 77.85 311.85 86.25 303.25 94.8 287.7 94.8 L 274.7 94.8 274.7 29.45 287.7 29.45 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_4)",
    stroke: "none",
    d: " M 441.9 48.85 Q 436.2 38.75 426.1 33.3 416.05 27.9 403.05 27.9 389.8 27.9 379.55 33.55 369.3 39.1 363.6 49.45 357.9 59.85 357.9 73.85 357.9 87.75 363.7 98.15 369.45 108.55 379.7 114.15 389.95 119.7 403.05 119.7 413.9 119.7 422.75 115.7 431.5 111.75 437.35 104.7 443.2 97.65 445.5 88.85 L 416.35 88.85 Q 412.35 97.5 402.1 97.5 395.25 97.5 390.5 93.05 385.8 88.7 385.15 80.4 L 447.05 80.4 Q 447.5 76.2 447.5 72.35 447.5 58.9 441.9 48.85 M 414.7 54 Q 419.55 58.15 419.55 65.15 L 385.35 65.15 Q 386.4 57.85 391.1 53.85 395.85 49.8 402.75 49.8 409.95 49.8 414.7 54 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    stroke: "none",
    d: " M 502.2 146.2 Q 499.4 146.2 497.4 148.15 495.45 150.15 495.45 152.95 L 495.45 153 Q 495.45 155.8 497.4 157.75 499.4 159.75 502.2 159.75 L 631.3 159.75 Q 634.1 159.75 636.05 157.75 638.05 155.8 638.05 153 L 638.05 152.95 Q 638.05 150.15 636.05 148.15 634.1 146.2 631.3 146.2 L 502.2 146.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    stroke: "none",
    d: " M 522.45 36.2 Q 512.75 27.9 495.95 27.9 484.6 27.9 476.35 31.6 468.15 35.25 463.9 41.6 459.6 47.9 459.6 55.55 459.6 64.7 464.3 70 468.9 75.4 475.3 77.9 481.75 80.4 491.35 82.6 500.3 84.85 504.3 86.65 508.3 88.55 508.3 92.35 508.3 95.55 505.5 97.6 502.65 99.55 497.6 99.55 491.95 99.55 488.15 96.65 484.3 93.85 483.85 89.15 L 456.8 89.15 Q 457.45 97.85 462.65 104.8 468 111.75 477.1 115.7 486.2 119.7 497.9 119.7 508.75 119.7 517.05 116.2 525.25 112.65 529.6 106.5 534.05 100.4 534.05 92.5 533.9 83.2 529.15 77.75 524.45 72.2 518.2 69.7 511.95 67.3 502.05 64.7 493.45 62.75 489.3 60.85 485.25 58.9 485.25 55.1 485.25 51.9 487.8 50 490.4 48.2 495.15 48.2 500.8 48.2 504.25 50.95 507.65 53.7 508.3 58.3 L 533.6 58.3 Q 532.1 44.55 522.45 36.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_7)",
    stroke: "none",
    d: " M 601.6 74 L 638.7 29.15 604.95 29.15 577.9 65.5 577.9 0 550.55 0 550.55 118.45 577.9 118.45 577.9 81.05 605.1 118.45 639.1 118.45 601.6 74 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.04522705078125, 0, 0, 1.0444488525390625, 0,0) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MD_Blue_0_Layer0_0_FILL"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydeskBlue);
export default __webpack_public_path__ + "static/media/mydesk_blue.540aaf0f2e23422362c9309413a1c658.svg";
export { ForwardRef as ReactComponent };